/* eslint-disable no-console */
import React, { ReactNode, useEffect, useState } from 'react';
import { getBrazeUnViewedContentCardCount } from '../utils/braze';

declare global {
  interface Window {
    __brazeContentCards?: Promise<Response>;
  }
}

type Response = {
  response?: {
    getUnviewedCardCount: () => number;
  } | null;
  error?: any;
};

type TBrazeContentCardCount = {
  children?: (count: number) => ReactNode;
  isEnabled?: boolean;
};

const BrazeContentCardCount = ({ children, isEnabled }: TBrazeContentCardCount) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!isEnabled) return;

    let isActive = true;

    getBrazeUnViewedContentCardCount()
      .then((unviewedCount) => {
        if (isActive) {
          setCount(unviewedCount);
        }
      })
      .catch((error) => {
        console.error('BrazeCount: error fetching unviewed content card count', error);
      });

    return () => {
      isActive = false;
    };
  }, [isEnabled]);

  return <>{children?.(count)}</>;
};

export default BrazeContentCardCount;
